import Vue from 'vue'
import Vuex from 'vuex'
import cache from 'vuex-cache'
import persistence from 'vuex-localstorage'
import { name, version } from '@/../package'
import * as modules from '@store/modules'

Vue.use(Vuex)
const settings = {
  namespace: `${name}@${version}`,
  timeout: 2 * 24 * 60 * 60 * 1000
}

const store = new Vuex.Store({
  modules,
  strict: true,
  plugins: [cache, persistence(settings)]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js